/**
 * IMPORTS
 */
import AxiosService from "@/infra/http/axios";

const tiposEntregaRepository: any = {
  /**
   * Função para buscar os tipo de entregas
   * @param accessToken
   * @returns Promise<any | null>
   */
  async getAllTiposEntrega<T>(
    accessToken: string,
    currentPage: number = 1,
    itemsPerPage: number = 10,
    searchItem: string
  ): Promise<T | null> {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const tipoEntregas = await Instance.get(
      `tipos-entrega?_page=${currentPage}&_limit=${itemsPerPage}&search=${searchItem}`,
      {
        headers: {
          "content-type": "application/json; charset=UTF-8",
          accept: "*/*",
        },
      }
    );

    return tipoEntregas?.data;
  },

  async criarNovoTiposEntrega(accessToken: string | undefined, payload: any) {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const tipoEntregaCriado = await Instance.post(`tipos-entrega/`, payload, {
      headers: {
        "content-type": "application/json; charset=UTF-8",
        accept: "*/*",
      },
    });

    return tipoEntregaCriado?.data;
  },

  async vincularTiposEntregaUsuario(accessToken: string | undefined, payload: any) {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const vinculoTipoEntregas = await Instance.post(
      `tipos-entrega/vincular-tipos-entrega/users`,
      payload,
      {
        headers: {
          "content-type": "application/json; charset=UTF-8",
          accept: "*/*",
        },
      }
    );

    return vinculoTipoEntregas?.data;
  },

  async atualizarTiposEntregaUsuario(accessToken: string | undefined, payload: any) {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const atualizarTiposEntrega = await Instance.post(`tipos-entrega/atualizar/users`, payload, {
      headers: {
        "content-type": "application/json; charset=UTF-8",
        accept: "*/*",
      },
    });

    return atualizarTiposEntrega?.data;
  },
};

/**
 * EXPORTS
 */
export { tiposEntregaRepository };
